import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {DrawerSubtitle as RmwcDrawerSubtitle} from '@rmwc/drawer'
import '@rmwc/drawer/styles'

const StyledRmwcDrawerSubtitle = styled(RmwcDrawerSubtitle)`
  &&& {
    font-family: 'Inter', sans-serif;
    font-size: 18px;
    font-weight: 400;
    line-height: 24.55px;
  }
  .mdc-theme--on-primary2 &&& {
    color: var(--mdc-theme-on-primary2);
  }
`

const DrawerSubtitle = ({children, ...otherProps}) => <StyledRmwcDrawerSubtitle {...otherProps}>{children}</StyledRmwcDrawerSubtitle>

DrawerSubtitle.propTypes = {
  children: PropTypes.any
}

export {DrawerSubtitle}
